/**
 * All Sliders
 * based on Swiper 5
 * @url : https://swiperjs.com/api/
 */

import $ from 'jquery'
import Swiper from 'swiper'

/**
 * Grid Slider (Home page)
 * Réglages différents basés sur la taille d'écran:
 * - small/medium : Carousel horizontal classique, 1 article par slide (total 18 slides)
 * - large+ : Carousel avec une grille de 6 articles par slide (total 3 slides)
 */

const gridSlider = document.querySelector('.js-grid-slider');

if (gridSlider) {

  const processGrid = () => {

    // Swiper generic options (all breakpoints)
    let swiperOpts = {
      speed: 700,
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      init: false
    }

    // Get all slides in memory
    let slides = [];
    const articles = gridSlider.querySelectorAll('.swiper-wrapper > div');
    $(gridSlider).find('.swiper-wrapper > div').remove();

    // Slides on Large and up
    if (Foundation.MediaQuery.atLeast('large')) {

      // DOM Modification
      for(var i = 0; i < articles.length; i+=6) {
        const $swiperSlide = $('<div></div>', { 'class': 'swiper-slide' });

        $(articles).slice(i, i+6).appendTo($swiperSlide);
        slides.push($swiperSlide[0]);
      }
      // add option for Large and up
      swiperOpts.spaceBetween = 30;

    // Slides on Small / Medium
    } else {

      // DOM Modification
      $(articles).each((i, el) => {
        const $swiperSlide = $('<div></div>', { 'class': 'swiper-slide' });
        $(el).appendTo($swiperSlide);
        slides.push($swiperSlide[0]);
      });

      // add option for Small / Medium
      swiperOpts.slidesPerView = 'auto';
    }

    // Init Swiper paused
    const gridSwiper = new Swiper(gridSlider, swiperOpts);
    // Append Slides to Swiper
    gridSwiper.appendSlide(slides);
    // Update Swiper with new slides
    gridSwiper.update();
    // Launch
    gridSwiper.init();
  }

  // Init on load
  processGrid();

  // Reinit after Mediaquery change
  $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {

    // TODO Reinit
    //processGrid();

  });
}


/**
 * News Slider
 */
const newsSliders = document.querySelectorAll('.js-related-posts-slider');

if (newsSliders.length) {

  for (const slider of newsSliders) {

    const newsSlider = new Swiper(slider, {
      slidesPerView : 'auto',
      freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  }
}


/**GALLERY SLIDER**/
const detailGallery = document.querySelector('.js-detail-slider');

if (detailGallery) {

  const galleryThumbs = new Swiper('.js-gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 6,
    // freeMode: true,
    centeredSlides: true,
    slideToClickedSlide: true,
  });

  const galleryTop = new Swiper('.js-gallery-top', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  galleryTop.controller.control = galleryThumbs;
  galleryThumbs.controller.control = galleryTop;

}



/**COUNTRIES SLIDER**/

const countriesSliders = document.querySelectorAll('.js-countries-slider');

function enableSwiper() {
  countriesSliders.forEach(countriesSlider => {
    const sliderWidth = countriesSlider.getBoundingClientRect().width;
    let slidesDims = 0;

    countriesSlider.querySelectorAll('.swiper-slide').forEach((slide) => {
      slidesDims = slidesDims + slide.getBoundingClientRect().width+20;
    });
    countriesSlider.classList.toggle('swiper-no-swiping', sliderWidth > slidesDims);

  })
}

if (countriesSliders) {

  let timeOut
  const observer = new MutationObserver((mutationList)=> {
    window.clearTimeout(timeOut)
    timeOut=window.setTimeout(()=>{
      for(const mutation of mutationList) {
        const target=mutation.target

        const swiperEl=target.querySelector('.js-countries-slider')

        const swiper=swiperEl.swiper

        if (swiper) {
          swiper.update()
        }
      }
    }, 1000)
  });

  const navigationSticky=document.querySelector('.navigation__sticky')
  observer.observe(navigationSticky,{
    attributes:true,
    subtree:false,
    attributeFilter:['class']
  })

  for (const slider of countriesSliders) {

    const countrySlider = new Swiper(slider, {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  }

  enableSwiper();
  window.addEventListener('resize', enableSwiper);
}
